import initialstate from '../initialstate';
import * as types from '../../actions/actiontypes';
import {cloneDeep} from 'lodash';

export default function uploadDocumentReducer(state = initialstate.uploadDocuments, action) {
	switch (action.type) {
		case 'KRONOS_UPCHUNK_CREATE_DOCUMENT_METADATA': {
			const payload = action.data;
			if (!action.error) {
				const data = action.responseObj.data;
				if (payload) {
					return Object.assign({}, state, {
						[payload.file?.name + '_' + data.id]: {
							documentName: payload.file?.name.substring(0, payload.file?.name.lastIndexOf('.')),
							documentId: data.id,
							id: data.id,
							fileExt: data.fileExtension,
							documentTypeId: data.documentTypeID,
							documentSourceId: data.documentSourceId,
							sourceEngagementId: data.engagementId,
							parentName: 'evidences',
							entityUid: payload.entityUid,
							sectionId: payload.file?.sectionId,
							inProgress: true,
							progressPercent: 0,
							totalPercentage: 100,
							isDragAndDrop: true
						}
					});
				}
			}

			return state;
		}
		case 'KRONOS_UPCHUNK_DOCUMENT_UPLOAD_COMPLETE': {
			let docObjFromAction = action.meta.upchunk;
			let payload = docObjFromAction.payload;

			if (!payload) {
				return state;
			}
			let fileName = payload.fileName;
			let itemKey = fileName + '_' + payload.documentId;
			let updatedState = {
				...state[itemKey],
				documentId: payload.documentId,
				inProgress: false,
				progressPercent: 100,
				totalPercentage: 100
			};
			return Object.assign({}, state, {
				[itemKey]: updatedState
			});
		}
		case 'KRONOS_UPCHUNK_DOCUMENT_UPLOAD_PROGRESS': {
			let docObjFromAction = action.meta.upchunk;
			let payload = docObjFromAction.payload;

			let fileName = payload && payload.fileName;
			let itemKey = fileName + '_' + payload.documentId;
			let updatedState = {
				...state[itemKey],
				documentId: payload.documentId,
				inProgress: true,
				progressPercent: payload.progressPercent === 100 ? 60 : payload.progressPercent, // document upload is complete but other tasks are still in progress.
				totalPercentage: 100
			};
			return Object.assign({}, state, {
				[itemKey]: updatedState
			});
		}
		case 'KRONOS_UPCHUNK_UPLOAD_COMPLETE': {
			return state;
		}
		case 'KRONOS_UPCHUNK_DOCUMENT_UPLOAD_TASKS_COMPLETE': {
			let docId = action?.meta?.documentId;
			let name = action?.meta?.fileName;
			let stateCopy = {...state};
			delete stateCopy[name + '_' + docId];
			return stateCopy;
		}
		case 'KRONOS_DOCUMENT_ERRORS': {
			// remove file which failed to upload from the list
			let newState = state.filter((element) => element.fileId !== action?.action?.meta?.upload?.fileId);
			return newState;
		}
		case 'KRONOS_UPCHUNK_DOCUMENT_UPLOAD_CANCELLED': {
			// Put back to default state
			return {};
		}
		case 'KRONOS_UPCHUNK_UPLOAD_ERROR': {
			// Put back to default state
			return {};
		}
		case types.REMOVE_TASK_DOCUMENT: {
			const uploads = cloneDeep(state);
			const keys = [];

			const entries = Object.entries(uploads);

			if (uploads && entries.length > 0) {
				entries.forEach(([key, upload]) => {
					if (`${upload.documentName}.${upload.fileExt}` === action.documentName) {
						keys.push(key);
					}
				});
			}

			if (keys.length > 0) {
				keys.forEach((key) => {
					delete uploads[key];
				});
			}

			return uploads;
		}
	}

	return state;
}
